// ==============================================
// Central app configuration
// ==============================================
// Single source of truth for the backend base URL. Override it with
// REACT_APP_API_URL in .env — no code changes needed to point at a new backend.

const RAW_API_URL =
  process.env.REACT_APP_API_URL ||
  'https://fazeelayazqasimi-botboss-updated-backend.hf.space';

// Normalised base URL with any trailing slash removed, so `${API_URL}/jobs/` is safe.
export const API_URL = RAW_API_URL.replace(/\/+$/, '');

// Hostname only — used by the auth fetch interceptor to recognise our API calls.
export const API_HOST = (() => {
  try { return new URL(API_URL).host; } catch { return ''; }
})();

// Optional separate microservice for behavioural analysis (local dev by default).
export const BEHAVIOR_API_URL =
  (process.env.REACT_APP_BEHAVIOR_URL || 'http://localhost:8000').replace(/\/+$/, '');
